import { z } from 'zod';
import { bindUnvalidatableInputMaker } from '../util.make-unvalidatable-input.js';

const makeInput = bindUnvalidatableInputMaker();
const inTableReadonlyInput = makeInput({
  schema: z.object({
    type: z.literal("ReadOnly"),
    text: z.string().optional().default(""),
    style: z.object({
      align: z.enum(["Left", "Center", "Right"]).default("Center"),
      bold: z.boolean().default(false),
      italic: z.boolean().default(false)
    }).default({
      align: "Center",
      bold: false,
      italic: false
    })
  }),
  postprocessSchemaInput: ({
    text,
    style
  }, context) => {
    return {
      id: `${context.taskId}-${context.rowIndex}-${context.index}`,
      nodeType: "in-table-readonly",
      text,
      style,
      meta: {
        rowIndex: context.rowIndex
      }
    };
  }
});

export { inTableReadonlyInput };
//# sourceMappingURL=input.readonly.js.map
